(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["oto-chair-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadChairCarousel = () => {
      if (customElements.get('oto-chair-carousel')) return;
      const section = document.querySelector('oto-chair-carousel[data-controller-url]');
      if (!section || document.querySelector('script[data-occ-loader]')) return;
      const script = document.createElement('script');
      script.dataset.occLoader = '';
      script.src = section.dataset.controllerUrl;
      script.addEventListener('error', () => script.remove(), { once: true });
      document.head.append(script);
    };
    loadChairCarousel();
    document.addEventListener('DOMContentLoaded', loadChairCarousel, { once: true });
    document.addEventListener('shopify:section:load', loadChairCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oto-chair-scene-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadChairCarousel = () => {
      if (customElements.get('oto-chair-carousel')) return;
      const section = document.querySelector('oto-chair-carousel[data-controller-url]');
      if (!section || document.querySelector('script[data-occ-loader]')) return;
      const script = document.createElement('script');
      script.dataset.occLoader = '';
      script.src = section.dataset.controllerUrl;
      script.addEventListener('error', () => script.remove(), { once: true });
      document.head.append(script);
    };
    loadChairCarousel();
    document.addEventListener('DOMContentLoaded', loadChairCarousel, { once: true });
    document.addEventListener('shopify:section:load', loadChairCarousel);
  })();

  } catch(e) { console.error(e); }
})();
})();
